import React, { Component } from 'react';
import StepHeader from './step-header';
import CheckoutPart1 from './checkout-part-1';
import { connect } from 'react-redux';
import OrderSummary from './order-summary';
import CheckoutPart2 from './checkout-part-2';
import { fetchCart } from '../actions';

class CheckoutMain extends Component {
	constructor( props ) {
		super( props );
		const cartInfo = getCartInfo();
		this.steps = [
			{ id: 1, name: 'Cart' }, { id: 2, name: 'Payment' }
			// Add more steps as needed
		];
		this.toggleStep = this.toggleStep.bind( this );
		this.submitted_order = cartInfo.submitted_order;
		this.imisError = cartInfo.checkout_errors;

		this.state = {
			activeStep: (this.submitted_order || this.imisError
			            ) ? 2 : 1
		};
		this.props.fetchCart();

	}

	toggleStep( step ) {
		this.setState( { activeStep: step } );
	}

	render() {
		return (<div className="container">
				<StepHeader steps={ this.steps }
				            activeStep={ this.state.activeStep }/>
				{ this.state.activeStep === 1 ? <CheckoutPart1/> :
				  <CheckoutPart2
					  backToCart={ this.toggleStep.bind( this, 1 ) }/> }
				<OrderSummary currentStep={ this.state.activeStep }
				              onClickCheckout={ this.toggleStep.bind( this, this.state.activeStep === 1
				                                                            ? 2
				                                                            : 1 ) }/>
			</div>
		);
	}
}

function mapStateToProps( { cart } ) {
	return {
		cart
	};
}

export default connect( mapStateToProps, {
	fetchCart
} )( CheckoutMain );